import styled from "@emotion/styled";

//  container
export const Container = styled.div`
  height: 100%;
`;

export const ClientsContainer = styled.div`
  display: grid;
  padding: 3rem;
`;

export const SpinnerContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
